import { Customer } from '@mews-commander/data-access';
import { getImageUrlOrNull } from '@mews-commander/utils';
import { getImageBaseUrl } from '../../../app/reducers/configuration';

export const useCustomerImageUrl = (customer: Customer | undefined) => {
    const imageBaseUrl = getImageBaseUrl();
    if (!customer) return '';
    const getSaveImageUrl = getImageUrlOrNull(imageBaseUrl);
    const { imageId } = customer;
    return getSaveImageUrl({ imageId }) ?? '';
};
